export const googleDriveConfig = {
  dev: {
    CLIENT_ID: '780971451088-32c31q277g9p3f9ek8ejun3iml2vu8cp.apps.googleusercontent.com',
    API_KEY: 'AIzaSyBJ12LMW8kFjNgH-NDG72LAbrcwTtFIKG8',
    CLIENT_SECRET: 'OkXZYoQOco_pFTEFOwtFyqD5',
  },
  pro: {
    CLIENT_ID: '213663974688-rulutt2tdc6h81dv8ssfev6hcn4kf118.apps.googleusercontent.com', // Foxit PDF Editor
    API_KEY: 'AIzaSyDLYb3hjfYt5WA_qq6khfLRCEggs03lyX4',
    CLIENT_SECRET: '4CQXCj2tUQ7_QUp6c_1WiGu-',
  },
}
export const oneDriveConfig = {
  dev: {
    CLIENT_ID: 'e8a6ab60-709f-493e-a732-f8eac93911f0'
  },
  pro: {
    CLIENT_ID: '847ad09a-fd45-4098-93d4-ae9ed4c3bd9f'
  }
}
export const dropBoxConfig = {
  dev: {
    CLIENT_ID: 'y9uh0oky1hyujc1'
  },
  pro: {
    CLIENT_ID: 'u4smzgeon8go2jd'
  }
}
export const boxConfig = {
  dev: {
    CLIENT_ID: 'q78tuz3jfzbsjfi4ikb9edi923okapgz',
    CLIENT_SECRET: '0OKurvR374jmRcirVylbDVUy1LL0gJmP',
  },
  pro: {
    CLIENT_ID: '0owr3qpuj1i4fgsqsn2zrbc6h4ksewlr',
    CLIENT_SECRET: 'C3XQVkHm3eJyE1DECdQhnnIXXuqX5DOg',
  }
}
export const awsSqsConfig = {
  pro: {
    AccessKeyId: 'AKIATO7ANFBZ3PVUHQVJ',
    SecretKey: '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'
  }
}